module.exports = __webpack_public_path__ + "img/vv_logo.417eb70f.png";